export default __webpack_public_path__ + "static/media/TEXTURA_01.0140da03.png";